<script lang="ts">
    import {Component, mixins, toNative} from 'vue-facing-decorator'
    import BookingPageBase from '~src/components/parts/bookingPageBase.src'
    import {PackagesStoreMixin} from '@/mixins/PackagesStoreMixin.vue'

    @Component({mixins: [BookingPageBase]})
    export class PackageBookingPageLayout extends mixins(PackagesStoreMixin) {
        clearCommentsAfterBooking() {}

        get productSearchPageName() {
            return 'packages'
        }

        get productConfirmationPageName() {
            return 'packageConfirmation'
        }

        get productName() {
            return 'package'
        }

        get productBookingPageName() {
            return 'packageBooking'
        }

        get corporatePolicyType() {
            return 'package'
        }

        get corporatePolicyViolated() {
            return packagesStore.prepareBookResponse && packagesStore.prepareBookResponse.corporatePolicyViolation
                ? packagesStore.prepareBookResponse.corporatePolicyViolation
                : false
        }

        get violatedPolicies() {
            return this.productStore.prepareBookResponse ? this.productStore.prepareBookResponse.corporatePolicies : []
        }
    }

    export default {...toNative(PackageBookingPageLayout), ssrRender: BookingPageBase.ssrRender}
</script>
